document.addEventListener("DOMContentLoaded", function () {
  const validAFMs = ["078746135", "168649877","Sunlover1993"];

  const input = document.getElementById("afm");
  const button = document.getElementById("b2b-access-btn");
  const error = document.getElementById("b2b-error");

  if (!input || !button) return;

  function hideError() {
    if (error) error.style.display = "none";
  }

  function showError() {
    if (error) error.style.display = "block";
  }

  function checkAFM() {
    hideError();

    const value = input.value.replace(/\s+/g, "");

    if (validAFMs.includes(value)) {
      button.disabled = true;
      button.textContent = "Access granted...";
      localStorage.setItem("sunlover_b2b_access", "granted");
      window.location.href = "/collections/wholesale-catalogue?b2b=granted";
      return;
    }

    showError();
  }

  button.addEventListener("click", checkAFM);

  input.addEventListener("input", hideError);

  input.addEventListener("keydown", function (event) {
    if (event.key === "Enter") {
      event.preventDefault();
      checkAFM();
    }
  });
});